(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-header"]) return;
  try {
    
  (function () {
    var header = document.getElementById('pf-header');
    if (!header) return;

    function setHeaderHeight() {
      document.documentElement.style.setProperty('--pf-header-height', header.offsetHeight + 'px');
    }
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight, { passive: true });
    window.addEventListener('load', setHeaderHeight);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setHeaderHeight);
    }

    /* -------- Mobile menu drawer: open/close + Esc + focus trap ---------- */
    var drawer = document.querySelector('[data-pf-drawer]');
    var drawerPanel = drawer ? drawer.querySelector('.pf-drawer__panel') : null;
    var drawerLastFocus = null;

    function drawerFocusables() {
      return drawerPanel
        ? Array.prototype.slice.call(
            drawerPanel.querySelectorAll('a[href], button:not([disabled])')
          )
        : [];
    }
    function trapDrawerFocus(e) {
      if (e.key !== 'Tab') return;
      var f = drawerFocusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    function onDrawerKeydown(e) {
      if (e.key === 'Escape') closeDrawer();
      else trapDrawerFocus(e);
    }
    function openDrawer(opener) {
      if (!drawer) return;
      drawerLastFocus = opener || document.activeElement;
      drawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onDrawerKeydown);
      var closeBtn = drawer.querySelector('.pf-drawer__close');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.removeAttribute('open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onDrawerKeydown);
      if (drawerLastFocus && typeof drawerLastFocus.focus === 'function') drawerLastFocus.focus();
    }
    document.querySelectorAll('[data-pf-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openDrawer(btn); });
    });
    document.querySelectorAll('[data-pf-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    /* -------- Cart: open the drawer + keep the count badge live --------- */
    function updateCartCount(count) {
      var el = document.querySelector('[data-pf-cart-count]');
      if (!el) return;
      var n = typeof count === 'number' ? count : parseInt(count, 10) || 0;
      el.textContent = n;
      el.classList.toggle('pf-header__cart-count--empty', n < 1);
      var link = el.closest('a');
      if (link) link.setAttribute('aria-label', 'Cart (' + n + ' item' + (n === 1 ? '' : 's') + ')');
    }
    function refreshCartCount() {
      var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) updateCartCount(c.item_count); })
        .catch(function () {});
    }
    document.querySelectorAll('[data-pf-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.open === 'function') {
          e.preventDefault();
          cd.open(el);
        }
      });
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.cartData && typeof evt.cartData.item_count === 'number') updateCartCount(evt.cartData.item_count);
        else refreshCartCount();
      });
    }
    document.addEventListener('cart:refresh', refreshCartCount);

    var searchBtn = document.getElementById('pfSearchBtn');
    var searchModal = document.getElementById('pfSearchModal');
    var searchOverlay = document.getElementById('pfSearchOverlay');
    var searchClose = document.getElementById('pfSearchClose');

    if (searchBtn && searchModal && searchOverlay && searchClose) {
      var lastFocusedBeforeSearch = null;

      function trapFocusInSearch(e) {
        if (e.key !== 'Tab') return;
        var focusable = searchModal.querySelectorAll('button, input, a[href]');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      searchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        lastFocusedBeforeSearch = document.activeElement;
        searchModal.classList.add('active');
        searchOverlay.classList.add('active');
        searchModal.addEventListener('keydown', trapFocusInSearch);
        var input = searchModal.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      });

      function hideSearch() {
        searchModal.classList.remove('active');
        searchOverlay.classList.remove('active');
        searchModal.removeEventListener('keydown', trapFocusInSearch);
        if (lastFocusedBeforeSearch) lastFocusedBeforeSearch.focus();
      }

      searchClose.addEventListener('click', hideSearch);
      searchOverlay.addEventListener('click', hideSearch);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchModal.classList.contains('active')) {
          hideSearch();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'pf_recently_viewed';
    var MAX_ITEMS = 8;

    function getViewed() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        return [];
      }
    }

    function saveViewed(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {}
    }

    function recordCurrentProduct(handle) {
      if (!handle) return;
      var list = getViewed().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
      saveViewed(list);
    }

    function renderSection(container) {
      var currentHandle = container.getAttribute('data-current-handle');
      var grid = container.querySelector('[data-pf-recent-grid]');
      var handles = getViewed().filter(function (h) { return h !== currentHandle; }).slice(0, 4);

      if (handles.length === 0) {
        container.classList.remove('pf-recent--has-items');
        return;
      }

      Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + handle + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        products = products.filter(Boolean);
        if (products.length === 0) {
          container.classList.remove('pf-recent--has-items');
          return;
        }
        grid.innerHTML = products.map(function (p) {
          var img = (p.featured_image || (p.images && p.images[0])) || '';
          var price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR' });
          return '<a class="pf-recent-card" href="' + p.url + '">' +
            (img ? '<img src="' + img + '&width=400" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '<div class="pf-recent-card__body">' +
              '<div class="pf-recent-card__title">' + p.title + '</div>' +
              '<div class="pf-recent-card__price">' + price + '</div>' +
            '</div>' +
          '</a>';
        }).join('');
        container.classList.add('pf-recent--has-items');
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      var container = document.getElementById('pf-recent-{{ section.id }}');
      if (!container) return;
      var currentHandle = container.getAttribute('data-current-handle');
      if (currentHandle) recordCurrentProduct(currentHandle);
      renderSection(container);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
